import { render } from "./indexDetails.vue?vue&type=template&id=a73c461a"
import script from "./indexDetails.vue?vue&type=script&lang=js"
export * from "./indexDetails.vue?vue&type=script&lang=js"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__